import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { RoleAction, RolePermissionSubject, Shift } from '@wilson/interfaces';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';

@Component({
  selector: 'wilson-new-shift-quick-creation-card',
  templateUrl: './new-shift-quick-creation-card.component.html',
  styleUrls: ['./new-shift-quick-creation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewShiftQuickCreationCardComponent {
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  readonly createNewViaDragAndDropService = inject(
    CreateNewViaDragAndDropService,
  );

  @Input() isQuickCreationCardOpen = true;

  public shift!: Shift;
  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  startDrag(event: DragEvent): void {
    this.createNewViaDragAndDropService.setEmptyShiftDropZone(true);
    this.dragAndDropModeService.setDisplayTimeVisible(false);
    this.dragAndDropModeService.setDraggingItemId(
      CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
    );
    // NOTE: to be used in unassigned section, to get correct start of the shift, based on left shift box border
    // Unassigned region does not use demarcator lines, to clarify start datetime of shift, but quick creation
    // card box border
    this.createNewViaDragAndDropService.setDragStartOffsetX(event.offsetX);
  }

  dragEnd(): void {
    this.createNewViaDragAndDropService.setEmptyShiftDropZone(false);
    this.dragAndDropModeService.setDraggingItemId(null);
    this.createNewViaDragAndDropService.setDragStartOffsetX(null);
  }
}
